export const DATE_FORMAT = 'yyyy-MM-dd';

export const CURRENCIES = {
	EUR: '€',
	USD: '$',
};
